<div class="component-container">
  <div class="loader loader1"></div>
  <div class="loader loader2"></div>
</div>
